import { Typography } from "@mui/material";

type PFieldLabel = {
    children?: string;
};

export function FieldLabelDecShort(props: PFieldLabel){
     return (
        <Typography mb={0} fontWeight="bold" fontSize={'small'} textAlign={{xs:'center',sm:'left'}}>
            {props.children}
        </Typography>
    );
}
export function FieldLabelDecLong(props: PFieldLabel){
     return (
        <Typography mb={0} fontWeight="normal" fontSize={'medium'} textAlign={{xs:'center',sm:'left'}}>
            {props.children}
        </Typography>
    );
}
export function FieldLabel(props: PFieldLabel) {
    return (
        <Typography mb={0} fontWeight="bold" textAlign={{xs:'center',sm:'left'}}>
            {props.children}
        </Typography>
    );
}

export function FieldSubLabel(props: PFieldLabel) {
    return (
        <Typography m={1} fontSize={"small"}>
            {props.children}
        </Typography>
    );
}
